import { render, staticRenderFns } from "./sidebar-bill-to-pax.vue?vue&type=template&id=67acc180&scoped=true&"
import script from "./sidebar-bill-to-pax.vue?vue&type=script&lang=js&"
export * from "./sidebar-bill-to-pax.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-bill-to-pax.vue?vue&type=style&index=0&id=67acc180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67acc180",
  null
  
)

export default component.exports